import type { WerksoortSleutel } from './work-quality.api';

/**
 * De doorklik naar de werksoort. Alle adressen staan hier, op één plek.
 *
 * Controles heeft geen werksoortlink meer: de productlink per voorbeeld komt van de dienst
 * (ExamplePair). Daarom geeft alleen Vastleggen (myxxtract) een link.
 */
export interface WerksoortLink {
  href: string;
  /** Sleutel van de tekst op de knop, in `qa.eigen.leerkaartLink.*`. */
  tekstSleutel: string;
}

export function werksoortLink(sleutel: WerksoortSleutel): WerksoortLink | null {
  if (sleutel !== 'myxxtract') return null;
  return { href: 'https://my.xxtract.com/', tekstSleutel: 'qa.eigen.leerkaartLinkMyxxtract' };
}
